import Component from '../inherited/Component';

export default class ShareButton extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
  }

  mount() {
    this._elem.addEventListener('click', async() => {
        try {
            await navigator.share(this._options);
            let textElem = this._elem.querySelector('[data-share-button-text]') || this._elem
            textElem.textContent = this._options.success
        } catch (err) {
        }
    });
}
}
